import React, { useState, useEffect } from "react";
import axios from "axios";
import currency from "../Assets/icons/curr.svg";
import swap from "../Assets/icons/swap.svg";

const CurrencyConverter = () => {
  const [exchangeRates, setExchangeRates] = useState({});
  const [sourceCurrency, setSourceCurrency] = useState("USD");
  const [targetCurrency, setTargetCurrency] = useState("INR");
  const [amount, setAmount] = useState(1);
  const [convertedAmount, setConvertedAmount] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [hideTooltip, setHideTooltip] = useState(false);

  useEffect(() => {
    fetchExchangeRates();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setHideTooltip(true);
      } else {
        setHideTooltip(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const fetchExchangeRates = async () => {
    try {
      const response = await axios.get(
        "https://api.exchangerate-api.com/v4/latest/USD"
      );
      setExchangeRates(response.data.rates);
    } catch (error) {
      console.error("Error fetching exchange rates:", error);
    }
  };

  const handleConvert = () => {
    const rate = exchangeRates[targetCurrency] / exchangeRates[sourceCurrency];
    const converted = amount * rate;
    setConvertedAmount(converted.toFixed(2));
  };

  const handleSwap = () => {
    const temp = sourceCurrency;
    setSourceCurrency(targetCurrency);
    setTargetCurrency(temp);

    const rate = exchangeRates[temp] / exchangeRates[targetCurrency];
    const converted = amount * rate;
    setConvertedAmount(converted.toFixed(2));
  };

  return (
    <div className="fixed bottom-8 right-8 z-50">
      <div className="relative">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-md focus:outline-none"
        >
          <img src={currency} alt="currency-icon" className="w-8 h-8" />
        </button>
        {!isOpen && !hideTooltip && (
          <div className="animate-bounce absolute bg-amber-400 text-base text-zinc-800 font-medium py-2 px-3 rounded-md -top-12 right-0 whitespace-nowrap shadow-md shadow-amber-500/50 ring ring-amber-400">
            Currency Converter
          </div>
        )}
        {isOpen && (
          <div className="fixed bottom-20 right-4 lg:right-8 xl:right-12 bg-white p-4 rounded-md border border-gray-300 shadow-md max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg">
            <h2 className="text-lg font-semibold mb-4 text-gray-800">
              Currency Converter
            </h2>
            <div className="mb-4">
              <label
                htmlFor="sourceCurrency"
                className="block text-gray-700 mb-1"
              >
                Your Currency:
              </label>
              <select
                id="sourceCurrency"
                value={sourceCurrency}
                onChange={(e) => setSourceCurrency(e.target.value)}
                className="block w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none"
              >
                {Object.keys(exchangeRates).map((currency) => (
                  <option key={currency} value={currency}>
                    {currency}
                  </option>
                ))}
              </select>
            </div>
            <button
              onClick={handleSwap}
              className="rounded-full p-1 flex justify-center mx-auto focus:outline-none"
            >
              <img src={swap} alt="Swap" className="w-6 h-6" />
            </button>
            <div className="mb-4">
              <label
                htmlFor="targetCurrency"
                className="block text-gray-700 mb-1"
              >
                New Currency:
              </label>
              <select
                id="targetCurrency"
                value={targetCurrency}
                onChange={(e) => setTargetCurrency(e.target.value)}
                className="block w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none"
              >
                {Object.keys(exchangeRates).map((currency) => (
                  <option key={currency} value={currency}>
                    {currency}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-4">
              <label htmlFor="amount" className="block text-gray-700 mb-1">
                Amount:
              </label>
              <input
                type="number"
                id="amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                className="block w-full py-2 px-3 border border-gray-300 rounded-md focus:outline-none"
              />
            </div>
            <button
              onClick={handleConvert}
              className="block w-full py-2 px-4 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none"
            >
              Convert
            </button>

            {convertedAmount && (
              <p className="mt-4 text-gray-800">
                {amount} {sourceCurrency} = {convertedAmount} {targetCurrency}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CurrencyConverter;
